import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/page/Page404')
const Page500 = () => import('@/views/page/Page500')
const Login = () => import('@/views/auth/Login')
const Register = () => import('@/views/auth/Register')
const ChangePassword = () => import('@/views/auth/ChangePassword')

// Users
const UserList = () => import('@/views/user/List')
const UserInfo = () => import('@/views/user/CreateOrUpdate')

// Zoning
const Zoning = () => import('@/views/zoning/List')
const ZoningCreateOrUpdate = () => import('@/views/zoning/CreateOrUpdate')

// estate
const EstateList = () => import('@/views/estate/List')
const EstateDetail = () => import('@/views/estate/Detail')

// Logs
const LogList = () => import('@/views/log/List')

// Logs
const Notif = () => import('@/views/notif/Push')

// Settings
const SettingList = () => import('@/views/setting/List')

// Ads
const AdsList = () => import('@/views/ads/List')

// Chart
const StatisticChart = () => import('@/views/statistic/Chart')

// Other
const ProvinceList = () => import('@/views/other/province/List')
const DistrictList = () => import('@/views/other/district/List')
const CommuneList = () => import('@/views/other/commune/List')
const ZoneTypeList = () => import('@/views/other/zoneType/List')
const EstateFormList = () => import('@/views/other/form/List')
const EstateTypeList = () => import('@/views/other/estateType/List')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({y: 0}),
  routes: configRoutes()
})
export default router

function configRoutes() {
  return [
    {
      path: '*',
      redirect: '/page/404',
      name: 'Error page'
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          meta: {title: 'Trang chủ'},
          component: Dashboard
        },
        {
          path: 'statistic',
          redirect: '/statistic/chart',
          name: 'Statistic',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'chart',
              name: 'Statistic Chart',
              meta: {title: 'Biểu đồ thống kê'},
              component: StatisticChart
            }
          ]
        },
        {
          path: 'zoning',
          redirect: '/zoning/list',
          name: 'Zoning',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'Zoning List',
              meta: {title: 'Tin tức quy hoạch'},
              component: Zoning
            },
            {
              path: 'map',
              name: 'Zoning Map',
              meta: {title: 'Bản đồ quy hoạch'},
              component: Zoning
            },
            {
              path: 'by-user',
              name: 'Zoning by User',
              meta: {title: 'Tin quy hoạch của user'},
              component: Zoning
            },
            {
              path: 'by-me',
              name: 'Zoning by Me',
              meta: {title: 'Tin quy hoạch của tôi'},
              component: Zoning
            },
            {
              path: 'new/:type',
              name: 'Zoning Create New',
              meta: {title: 'Đăng tin quy hoạch'},
              component: ZoningCreateOrUpdate
            },
            {
              path: 'edit/:zoningId',
              name: 'Zoning Update',
              meta: {title: 'Sửa tin quy hoạch'},
              component: ZoningCreateOrUpdate
            }
          ]
        },
        {
          path: 'estate',
          redirect: '/estate/list',
          name: 'Estate',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'Estate List',
              meta: {title: 'Danh sách mua bán'},
              component: EstateList
            },
            {
              path: 'news/:id',
              name: 'Estate Detail',
              meta: {title: 'Chi tiết mua bán'},
              component: EstateDetail
            }
          ]
        },
        {
          path: 'ads',
          name: 'Ads Setting',
          meta: {title: 'Cài đặt tin quảng cáo'},
          component: AdsList
        },
        {
          path: 'system',
          redirect: '/system/user',
          name: 'System',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'user',
              name: 'User List',
              meta: {title: 'Quản lý người dùng'},
              component: UserList
            },
            {
              path: 'notification',
              name: 'Push Notification',
              meta: {title: 'Thông báo đẩy'},
              component: Notif
            },
            {
              path: 'user-info',
              name: 'User Info',
              meta: {title: 'Thông tin tài khoản'},
              component: UserInfo
            },
            {
              path: 'my-profile',
              name: 'My Profile',
              meta: {title: 'Thông tin tài khoản cá nhân'},
              component: UserInfo
            },
            {
              path: 'log',
              name: 'System Log',
              meta: {title: 'Logs hệ thống'},
              component: LogList
            },
            {
              path: 'setting',
              name: 'System Setting',
              meta: {title: 'Cài đặt hệ thống'},
              component: SettingList
            }
          ]
        },
        {
          path: 'other',
          redirect: '/other/province',
          name: 'Other',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'province',
              name: 'Province List',
              meta: {title: 'Quản lý cấp tỉnh'},
              component: ProvinceList
            },
            {
              path: 'district',
              name: 'District List',
              meta: {title: 'Quản lý cấp huyện'},
              component: DistrictList
            },
            {
              path: 'commune',
              name: 'Commune List',
              meta: {title: 'Quản lý cấp xã'},
              component: CommuneList
            },
            {
              path: 'zoneType',
              name: 'Zone Type List',
              meta: {title: 'Quản lý loại quy hoạch'},
              component: ZoneTypeList
            },
            {
              path: 'estateForm',
              name: 'Form List',
              meta: {title: 'Quản lý hình thức mua bán bất động sản'},
              component: EstateFormList
            },
            {
              path: 'estateType',
              name: 'Estate Type List',
              meta: {title: 'Quản lý loại hình bất động sản'},
              component: EstateTypeList
            },
          ]
        }
      ]
    },
    {
      path: '/page',
      redirect: '/page/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404,
          meta: {
            notRequiresAuth: true,
            title: 'Error 404',
          },
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
          meta: {
            notRequiresAuth: true,
            title: 'Error 500'
          },
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      name: 'Auth',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: {
            notRequiresAuth: true,
            title: 'Đăng nhập'
          },
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          meta: {
            notRequiresAuth: true
          },
        },
        {
          path: 'change-password',
          name: 'Change password',
          component: ChangePassword,
          meta: {
            notRequiresAuth: true,
            title: 'Thay đổi mật khẩu'
          },
        }
      ]
    }
  ]
}

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.notRequiresAuth)) {
    next() // does not require auth, make sure to always call next()!
  } else {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (Vue.$cookies.isKey('userInfo') && Vue.$cookies.get('userInfo')['tokenId']) {
      if (new Date(Vue.$cookies.get('userInfo')['expiredAt']).getTime() - new Date().getTime() <= 300000) {
        await store.dispatch('auth/userUpdateToken')
      }
      if (!Object.keys(store.getters['user/getAccountDetail']).length) {
        await store.dispatch('user/getUserDetail')
      }
      next()
    } else {
      if (window.location.pathname === '/') {
        next({name: 'Login'})
      } else {
        next({
          name: 'Login',
          params: {
            pathName: window.location.pathname
          },
          query: {
            isExpired: true
          }
        })
      }
    }
  }
  if (to.meta && to.meta.title) {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    document.title = nearestWithTitle.meta.title;
  }
})
